







import Vue from 'vue'
import TotalAffiliate from '@/components/molecules/Affiliate/TotalAffiliate.vue'
import XContainer from '@/components/atoms/Container/XContainer.vue'

export default Vue.extend({
  components: { TotalAffiliate, XContainer },
})
